import tempMeeApi from '../../../apis/tempMee';
import { CAMPAIGNS_ENDPOINT } from './GetCampaigns';

/**
 * One page of the offices a campaign's rule names by `office_id`, with display
 * names: `GET /v1/admin/campaigns/:id/target-offices` (campaign-service #140,
 * GOTU-8105). Sorted by name, then id, server-side.
 *
 * This is what the rule *names*, not who currently matches it — a geography
 * leaf under `or` can reach offices outside the list.
 *
 * `pageSize` is not sent: the service's default (50) applies and is echoed
 * back, so the caller pages on what it actually got.
 *
 * @param {string} campaignId
 * @param {Object} [params]
 * @param {number} [params.page=1] - 1-based page.
 * @param {string} [params.q] - Case-insensitive substring of office id or name.
 *   Omitted when empty. The service answers more than 200 characters with a 400.
 */
export const getCampaignTargetOffices = async (campaignId, { page = 1, q } = {}) => {
  const params = { page };
  if (q) params.q = q;

  const response = await tempMeeApi.get(`${CAMPAIGNS_ENDPOINT}/${campaignId}/target-offices`, {
    params,
  });

  return response.data;
};
